// import bag_09_13 from "../../../../src/images/frontpage/products/bag-09-07.jpg";
const starproductdata = [
    {
        products_sid: 3,
        products_tag:"推薦",
        products_name: "征服者(十包一入)",
        products_price: 320,
        products_content:
            "征服者入口可感受到濃郁的黑可克力口感,同時具有豐富且厚實的奶油風味",
        products_img: "bag3-1.jpg",
    },
    {
        products_sid: 4,
        products_tag:"推薦",
        products_name: "木蘭花(十包一入)",
        products_price: 320,
        products_content:
            "優雅的韻味瀰漫著蜂蜜堅果,百香果的香氣口感,同時具有宛如蔗糖般的濃郁香氣,在味蕾留下輕柔的口感",
        products_img: "bag4-1.jpg",
    },
    {
        products_sid: 17,
        products_tag:"推薦",
        products_name: "黃金曼巴(五包一入)",
        products_price: 170,
        products_content:
            "口感厚實甘醇的頂級黃金曼特寧搭配核果香氣絕佳的巴西咖啡豆,完美平衡呈現奶油的質感與明顯的可可味",
        products_img: "bag7-1.jpg",
    },
    {
        products_sid: 15,
        products_tag:"推薦",
        products_name: "瓜地馬拉花神(五包一入)",
        products_price: 170,
        products_content:
            "花神具有非常愉悅優雅花香主體的風味,酸性柔和且以巧克力般的風味尾韻作結,整體口感乾淨且明亮",
        products_img: "bag5-1.jpg",
    },
    {
        products_sid: 6,
        products_tag:"推薦",
        products_name: "耶加雪菲(十包一入)",
        products_price: 320,
        products_content:
            "日曬耶加雪菲具有濃郁奔放的水果香,柔和綿長的蜜桃莓果酸卻不刺激,風味甜度高酸度明亮且細膩",
        products_img: "bag6-1.jpg",
    },
    {
        products_sid: 59,
        products_tag:"推薦",
        products_name: "黃金曼特寧(一磅)",
        products_price: 940,
        products_content:
            "手選三次,挑選20目左右碩大的特優級曼特寧生豆,豆質結實緊密,豐富油脂帶出巧克力般滑順奶油般香甜",
        products_img: "bag8-1.jpg",
    },
    {
        products_sid: 12,
        products_tag:"推薦",
        products_name: "模範生(五包一入)",
        products_price: 170,
        products_content:
            "具有豐富的芳香水果酸氣迷人,且帶有柑橘的明亮甜感,巧克力的餘韻油脂感特佳",
        products_img: "bag2-1.jpg",
    },
    {
        products_sid: 61,
        products_tag:"推薦",
        products_name: "曼特寧(一磅)",
        products_price: 640,
        products_content:
            "為蘇門答臘最具代表的咖啡豆,其草本風味質感濃郁芳香度特強,口感厚實的甘甜味是它的獨到之處,對於不喜歡酸味的人的最佳選擇",
        products_img: "coffeeBean-29-17.jpg",
    },
    {
        products_sid: 52,
        products_tag:"推薦",
        products_name: "肯亞AA TOP(一磅)",
        products_price: 940,
        products_content:
            "AA TOP最高等級的肯亞咖啡豆其濃郁的黑梅香氣,口感豐富且尾韻悠長,轉化為肯亞特有的甜,一入口紅酒般的餘韻在口中揮之不去",
        products_img: "coffeeBean-11-1.jpg",
    },
    {
        products_sid: 60,
        products_tag:"推薦",
        products_name: "曼巴(一磅)",
        products_price: 320,
        products_content:
            "口感厚實甘醇的曼特寧搭配核果香氣絕佳的巴西咖啡豆,奶油的質感與明顯的可可味搭配後清雅的回甘口感一直會讓人回味無窮",
        products_img: "coffeeBean-29-11.jpg",
    },

];

export default starproductdata;
